function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * 多标签页
 * */
import { get, cloneDeep } from 'lodash';
import router from '@/router';
import Setting from '@/setting';
import menuSider from '@/menu/sider';
import { getAllSiderMenu, includeArray } from '@/libs/system';

// 判定是否需要缓存
var isKeepAlive = function isKeepAlive(data) {
  return get(data, 'meta.cache', false);
};
export default {
  namespaced: true,
  state: {
    // 可以在多页 tab 模式下显示的页面
    pool: [],
    // 当前显示的多页面列表
    opened: Setting.page.opened,
    // 当前页面
    current: '',
    // 需要缓存的页面 name
    keepAlive: []
  },
  actions: {
    /**
     * @description 从持久化数据载入分页列表
     */
    openedLoad: function openedLoad(_ref, _ref2) {
      var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState;
      var _ref2$loadOpenedTabs = _ref2.loadOpenedTabs,
        loadOpenedTabs = _ref2$loadOpenedTabs === void 0 ? true : _ref2$loadOpenedTabs;
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve) {
          var value, valid;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch('admin/db/get', {
                  dbName: 'sys',
                  path: 'page.opened',
                  defaultValue: Setting.page.opened,
                  user: true
                }, {
                  root: true
                });
              case 2:
                value = _context.sent;
                if (!loadOpenedTabs) value = [];
                // 在处理函数中进行数据优化 过滤掉现在已经失效的页签或者已经改变了信息的页签
                // 以 fullPath 字段为准
                // 如果页面过多的话可能需要优化算法
                // valid 有效列表 1, 1, 0, 1 => 有效, 有效, 失效, 有效
                valid = []; // 处理数据
                state.opened = value.map(function (opened) {
                  // 忽略首页
                  if (opened.fullPath === '/index') {
                    valid.push(1);
                    return opened;
                  }
                  // 尝试在所有的支持多标签页的页面里找到 name 匹配的页面
                  var find = state.pool.find(function (item) {
                    return item.name === opened.name;
                  });
                  // 如果 value 项有 keepMeta 字段，则保留 meta
                  if (opened.keepMeta) {
                    find.meta = Object.assign({}, opened.meta);
                  }
                  // 记录有效或无效信息
                  valid.push(find ? 1 : 0);
                  // 返回合并后的数据 新的覆盖旧的
                  // 新的数据中一般不会携带 params 和 query, 所以旧的参数会留存
                  return Object.assign({}, opened, find);
                }).filter(function (opened, index) {
                  return valid[index] === 1;
                })
                // 对 menu 鉴权过滤
                .filter(function (opened) {
                  var allSiderMenu = getAllSiderMenu(menuSider);
                  var find = allSiderMenu.find(function (item) {
                    return item.path === opened.fullPath;
                  });
                  var state = true;
                  if (find && find.auth) {
                    var userInfo = rootState.admin.user.info;
                    // @权限
                    var access = cloneDeep(userInfo.access);
                    // 给 access 强制加一个 hidden 的权限，否则菜单隐藏后，Tabs 页签会不显示该页签
                    access.push('hidden');
                    // 如果用户当前的权限，不是该 menu 对应的 权限，则过滤这个 Tab
                    if (access && !includeArray(find.auth, access)) state = false;
                  }
                  return state;
                });
                // 根据 opened 数据生成缓存设置
                commit('keepAliveRefresh');
                // end
                resolve();
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    /**
     * 将 opened 属性赋值并持久化 在这之前请先确保已经更新了 state.opened
     */
    opened2db: function opened2db(_ref4) {
      var state = _ref4.state,
        dispatch = _ref4.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // 设置数据
                dispatch('admin/db/set', {
                  dbName: 'sys',
                  path: 'page.opened',
                  value: state.opened,
                  user: true
                }, {
                  root: true
                });
                // end
                resolve();
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 更新页面列表上的某一项
     * @param {Object} param { index, params, query, fullPath } 路由信息
     */
    openedUpdate: function openedUpdate(_ref6, _ref7) {
      var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;
      var index = _ref7.index,
        params = _ref7.params,
        query = _ref7.query,
        fullPath = _ref7.fullPath,
        meta = _ref7.meta,
        _ref7$keepMeta = _ref7.keepMeta,
        keepMeta = _ref7$keepMeta === void 0 ? false : _ref7$keepMeta;
      return new Promise( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve) {
          var page;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                // 更新页面列表某一项
                page = state.opened[index];
                page.params = params || page.params;
                page.query = query || page.query;
                page.fullPath = fullPath || page.fullPath;
                page.meta = meta || page.meta;
                page.keepMeta = keepMeta;
                state.opened.splice(index, 1, page);
                // 持久化
                _context3.next = 9;
                return dispatch('opened2db');
              case 9:
                // end
                resolve();
              case 10:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref8.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 更新页面当前项
     * @param {Object} param { params, query, fullPath } 路由信息
     */
    currentUpdate: function currentUpdate(_ref9, _ref10) {
      var state = _ref9.state,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch;
      var params = _ref10.params,
        query = _ref10.query,
        fullPath = _ref10.fullPath,
        meta = _ref10.meta,
        _ref10$keepMeta = _ref10.keepMeta,
        keepMeta = _ref10$keepMeta === void 0 ? false : _ref10$keepMeta;
      return new Promise( /*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve) {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  var index, page;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        // 更新当前项
                        index = state.opened.findIndex(function (item) {
                          return item.fullPath === state.current;
                        });
                        page = state.opened[index];
                        page.params = params || page.params;
                        page.query = query || page.query;
                        page.fullPath = fullPath || page.fullPath;
                        page.meta = meta || page.meta;
                        page.keepMeta = keepMeta;
                        state.opened.splice(index, 1, page);
                        // 持久化
                        _context4.next = 10;
                        return dispatch('opened2db');
                      case 10:
                        // end
                        resolve();
                      case 11:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                })), 0);
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x4) {
          return _ref11.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 新增一个 tag (打开一个页面)
     * @param {Object} param new tag info
     */
    add: function add(_ref13, _ref14) {
      var state = _ref13.state,
        commit = _ref13.commit,
        dispatch = _ref13.dispatch;
      var tag = _ref14.tag,
        params = _ref14.params,
        query = _ref14.query,
        fullPath = _ref14.fullPath;
      return new Promise( /*#__PURE__*/function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve) {
          var newTag;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                // 设置新的 tag 在新打开一个以前没打开过的页面时使用
                newTag = tag;
                newTag.params = params || newTag.params;
                newTag.query = query || newTag.query;
                newTag.fullPath = fullPath || newTag.fullPath;
                // 添加进当前显示的页面数组
                state.opened.push(newTag);
                // 如果这个页面需要缓存 将其添加到缓存设置
                if (isKeepAlive(newTag)) {
                  commit('keepAlivePush', tag.name);
                }
                // 持久化
                _context6.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x5) {
          return _ref15.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 打开一个新的页面
     * @param {Object} param 从路由钩子的 to 对象上获取 { name, params, query, fullPath } 路由信息
     */
    open: function open(_ref16, _ref17) {
      var state = _ref16.state,
        commit = _ref16.commit,
        dispatch = _ref16.dispatch;
      var name = _ref17.name,
        params = _ref17.params,
        query = _ref17.query,
        fullPath = _ref17.fullPath;
      return new Promise( /*#__PURE__*/function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resolve) {
          var opened, pageOpenedIndex, pageOpened, page;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                // 已经打开的页面
                opened = state.opened; // 判断此页面是否已经打开 并且记录位置
                pageOpenedIndex = 0;
                pageOpened = opened.find(function (page, index) {
                  var same = page.fullPath === fullPath;
                  pageOpenedIndex = same ? index : pageOpenedIndex;
                  return same;
                });
                if (!pageOpened) {
                  _context7.next = 8;
                  break;
                }
                _context7.next = 6;
                return dispatch('openedUpdate', {
                  index: pageOpenedIndex,
                  params: params,
                  query: query,
                  fullPath: fullPath
                });
              case 6:
                _context7.next = 12;
                break;
              case 8:
                // 页面以前没有打开过
                page = state.pool.find(function (t) {
                  return t.name === name;
                }); // 如果这里没有找到 page 代表这个路由虽然在框架内 但是不参与标签页显示
                if (!page) {
                  _context7.next = 12;
                  break;
                }
                _context7.next = 12;
                return dispatch('add', {
                  tag: Object.assign({}, page),
                  params: params,
                  query: query,
                  fullPath: fullPath
                });
              case 12:
                commit('currentSet', fullPath);
                // end
                resolve();
              case 14:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x6) {
          return _ref18.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭一个 tag (关闭一个页面)
     * @param {Object} param { tagName: 要关闭的标签名字 }
     */
    close: function close(_ref19, _ref20) {
      var state = _ref19.state,
        commit = _ref19.commit,
        dispatch = _ref19.dispatch;
      var tagName = _ref20.tagName;
      return new Promise( /*#__PURE__*/function () {
        var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve) {
          var newPage, isCurrent, len, i, index, _newPage, _newPage$name, name, _newPage$params, params, _newPage$query, query, routerObj;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                // 下个新的页面
                newPage = state.opened[0];
                isCurrent = state.current === tagName; // 如果关闭的页面就是当前显示的页面
                if (!isCurrent) {
                  _context8.next = 12;
                  break;
                }
                // 去找一个新的页面
                len = state.opened.length;
                i = 0;
              case 5:
                if (!(i < len)) {
                  _context8.next = 12;
                  break;
                }
                if (!(state.opened[i].fullPath === tagName)) {
                  _context8.next = 9;
                  break;
                }
                // 是否只剩最后一个，是则跳首页
                if (len > 1) {
                  // 如果是最后一个，则向前一个跳，否则向下一个跳
                  if (i === len - 1) {
                    newPage = state.opened[i - 1];
                  } else {
                    newPage = state.opened[i + 1];
                  }
                } else {
                  newPage = {};
                }
                return _context8.abrupt("break", 12);
              case 9:
                i++;
                _context8.next = 5;
                break;
              case 12:
                // 找到这个页面在已经打开的数据里是第几个
                index = state.opened.findIndex(function (page) {
                  return page.fullPath === tagName;
                });
                if (index >= 0) {
                  // 如果这个页面是缓存的页面 将其在缓存设置中删除
                  commit('keepAliveRemove', state.opened[index].name);
                  // 更新数据 删除关闭的页面
                  state.opened.splice(index, 1);
                }
                // 持久化
                _context8.next = 16;
                return dispatch('opened2db');
              case 16:
                // 最后需要判断是否需要跳到首页
                if (isCurrent) {
                  _newPage = newPage, _newPage$name = _newPage.name, name = _newPage$name === void 0 ? 'index' : _newPage$name, _newPage$params = _newPage.params, params = _newPage$params === void 0 ? {} : _newPage$params, _newPage$query = _newPage.query, query = _newPage$query === void 0 ? {} : _newPage$query;
                  routerObj = {
                    name: name,
                    params: params,
                    query: query
                  };
                  router.push(routerObj, function () {});
                }
                // end
                resolve();
              case 18:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return function (_x7) {
          return _ref21.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前标签左边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeLeft: function closeLeft(_ref22) {
      var state = _ref22.state,
        commit = _ref22.commit,
        dispatch = _ref22.dispatch;
      var _ref23 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref23.pageSelect;
      return new Promise( /*#__PURE__*/function () {
        var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                if (currentIndex > 0) {
                  // 删除打开的页面 并在缓存设置中删除
                  state.opened.splice(1, currentIndex - 1).forEach(function (_ref25) {
                    var name = _ref25.name;
                    return commit('keepAliveRemove', name);
                  });
                }
                state.current = pageAim;
                if (router.currentRoute.value.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context9.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x8) {
          return _ref24.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前标签右边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeRight: function closeRight(_ref26) {
      var state = _ref26.state,
        commit = _ref26.commit,
        dispatch = _ref26.dispatch;
      var _ref27 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref27.pageSelect;
      return new Promise( /*#__PURE__*/function () {
        var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                // 删除打开的页面 并在缓存设置中删除
                state.opened.splice(currentIndex + 1).forEach(function (_ref29) {
                  var name = _ref29.name;
                  return commit('keepAliveRemove', name);
                });
                // 设置当前的页面
                state.current = pageAim;
                if (router.currentRoute.value.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context10.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        return function (_x9) {
          return _ref28.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前激活之外的 tag
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeOther: function closeOther(_ref30) {
      var state = _ref30.state,
        commit = _ref30.commit,
        dispatch = _ref30.dispatch;
      var _ref31 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref31.pageSelect;
      return new Promise( /*#__PURE__*/function () {
        var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                // 删除打开的页面数据 并更新缓存设置
                if (currentIndex === 0) {
                  state.opened.splice(1).forEach(function (_ref33) {
                    var name = _ref33.name;
                    return commit('keepAliveRemove', name);
                  });
                } else {
                  state.opened.splice(currentIndex + 1).forEach(function (_ref34) {
                    var name = _ref34.name;
                    return commit('keepAliveRemove', name);
                  });
                  state.opened.splice(1, currentIndex - 1).forEach(function (_ref35) {
                    var name = _ref35.name;
                    return commit('keepAliveRemove', name);
                  });
                }
                // 设置新的页面
                state.current = pageAim;
                if (router.currentRoute.value.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context11.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }));
        return function (_x10) {
          return _ref32.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭所有 tag
     * @param {Object} state vuex state
     */
    closeAll: function closeAll(_ref36) {
      var state = _ref36.state,
        commit = _ref36.commit,
        dispatch = _ref36.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(resolve) {
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                // 删除打开的页面 并在缓存设置中删除
                state.opened.splice(1).forEach(function (_ref38) {
                  var name = _ref38.name;
                  return commit('keepAliveRemove', name);
                });
                // 持久化
                _context12.next = 3;
                return dispatch('opened2db');
              case 3:
                // 关闭所有的标签页后需要判断一次现在是不是在首页
                if (router.currentRoute.value.name !== 'index') {
                  router.push({
                    name: 'index'
                  }, function () {});
                }
                // end
                resolve();
              case 5:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        return function (_x11) {
          return _ref37.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 直接更新 opened，用于拖拽调整页签顺序
     * */
    updateOpened: function updateOpened(_ref39, _ref40) {
      var state = _ref39.state,
        commit = _ref39.commit,
        dispatch = _ref39.dispatch;
      var opened = _ref40.opened;
      return new Promise( /*#__PURE__*/function () {
        var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(resolve) {
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                state.opened = opened;
                // 持久化
                _context13.next = 3;
                return dispatch('opened2db');
              case 3:
                // end
                resolve();
              case 4:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }));
        return function (_x12) {
          return _ref41.apply(this, arguments);
        };
      }());
    }
  },
  mutations: {
    /**
     * @class keepAlive
     * @description 从已经打开的页面记录中更新需要缓存的页面记录
     * @param {Object} state vuex state
     */
    keepAliveRefresh: function keepAliveRefresh(state) {
      state.keepAlive = state.opened.filter(function (item) {
        return isKeepAlive(item);
      }).map(function (e) {
        return e.name;
      });
    },
    /**
     * @description 删除一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAliveRemove: function keepAliveRemove(state, name) {
      var list = _toConsumableArray(state.keepAlive);
      var index = list.findIndex(function (item) {
        return item === name;
      });
      if (index !== -1) {
        list.splice(index, 1);
        state.keepAlive = list;
      }
    },
    /**
     * @description 增加一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAlivePush: function keepAlivePush(state, name) {
      var keep = _toConsumableArray(state.keepAlive);
      keep.push(name);
      state.keepAlive = keep;
    },
    /**
     * @description 清空页面缓存设置
     * @param {Object} state vuex state
     */
    keepAliveClean: function keepAliveClean(state) {
      state.keepAlive = [];
    },
    /**
     * @class current
     * @description 设置当前激活的页面 fullPath
     * @param {Object} state vuex state
     * @param {String} fullPath new fullPath
     */
    currentSet: function currentSet(state, fullPath) {
      state.current = fullPath;
    },
    /**
     * @class pool
     * @description 保存 pool (候选池)
     * @param {Object} state vuex state
     * @param {Array} routes routes
     */
    init: function init(state, routes) {
      var pool = [];
      var push = function push(routes) {
        routes.forEach(function (route) {
          if (route.children) {
            push(route.children);
          } else {
            if (!route.hidden) {
              var meta = route.meta,
                name = route.name,
                path = route.path;
              pool.push({
                meta: meta,
                name: name,
                path: path
              });
            }
          }
        });
      };
      push(routes);
      state.pool = pool;
    }
  }
};